var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentTemplate',{attrs:{"items":_vm.allItems,"fetch-key":'all'},on:{"load-more":function($event){return _vm.fetchMore()}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("\n\t\t"+_vm._s(_vm.t('news', 'All Articles'))+"\n\t")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }